export default "__VITE_ASSET__BvQUgRKh__"